export default __webpack_public_path__ + "static/media/hero1.3d35f73e.webp";